import { generateMessageId } from '../helper/session-id'
import { getUserId } from './storage'

export const track = (event, data) => {
  const normalizedData = normalizeData('track', data)
  normalizedData.event = event

  return enqueue('/t', normalizedData)
}

export const page = (pageName, data) => {
  const normalizedData = normalizeData('page', data)
  normalizedData.name = pageName

  return enqueue('/p', normalizedData)
}

/**
 *
 * @param {String} path
 * @param {message} message
 */
export const enqueue = (path, message) => {
  const url = `${process.env.API_URL}/api/webhooks/tracking${path}`
  const queue = window.getPerspectiveQueue()
  queue.addItem({
    url,
    message,
  })
}

/**
 *
 * @param type
 * @param data
 * @return {message}
 */
export const normalizeData = (type, data) => {
  return {
    timestamp: new Date().toISOString(),
    sentAt: new Date().toISOString(),
    context: {
      page: {
        path: window.location.pathname,
        referrer: document.referrer,
        search: window.location.search,
        title: document.title,
        url: window.location.href,
      },
      userAgent: window.navigator.userAgent,
      locale: window.navigator.language,
    },
    properties: data,
    messageId: `perspective-${generateMessageId()}`,
    type: type,
    anonymousId: getUserId(),
  }
}

export default {
  track,
  page,
}
